import {useEffect, useRef} from 'react';
import type {AstView} from 'rendition-core/types';

export const useAddKeyFramesToDocument = (view: AstView) => {
    const keyframeStyleTagRef = useRef(document.createElement('style'));

    useEffect(() => {
        const keyframeStyleTag = keyframeStyleTagRef.current;
        keyframeStyleTag.id = 'keyframe-style-tag';

        const keyframes = view.meta.cssKeyFrames;
        if (keyframes) {
            keyframeStyleTag.innerHTML = Object.keys(keyframes)
                .map((keyframeName) => {
                    const percentages = Object.keys(keyframes[keyframeName]);
                    const percentageLines = percentages
                        .map((percentage) => `${percentage}% ${keyframes[keyframeName][percentage]}`)
                        .join('\n\t');
                    return `@keyframes ${keyframeName} {\n\t${percentageLines}\n}`;
                })
                .join('\n');

            document.head.appendChild(keyframeStyleTag);
        }

        return () => {
            try {
                const tag = document.getElementById('keyframe-style-tag');
                if (tag) {
                    document.head.removeChild(tag);
                }
            } catch (e) {
                console.log(e);
            }
        };
    }, [view.meta.cssKeyFrames]);
};
